import { GetRequest, PostRequest } from "./http/BaseRequest";
import { BaseResponse } from "./http/responses/BaseResponse";

export interface ICreateTwoFA {
  Qr: string;
  Resetcode: string;
}

export interface Create_2faResponseI extends BaseResponse, ICreateTwoFA {}

/*
export const create_2fa = (): Promise<AxiosResponse<Create_2faResponseI> | Error> => {
  return service.api.get("/create_2fa");
};

export const reset_2fa = (reset_code: string): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.get("/reset_2fa_start", { params: { reset_code } });
};

export const clear_2fa = (user_id: number): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.post("/user/clear2fa", { user_id });
};
*/

export class Create2FaRequest extends GetRequest {
  constructor() {
    super("/create_2fa");
  }
}

interface IReset2FAParams {
  readonly reset_code: string;
  readonly recaptcha: string;
  readonly email: string;
  readonly password: string;
}

export class Reset2FaRequest extends GetRequest {
  constructor(params: IReset2FAParams) {
    super("/reset_2fa_start", params);
  }
}

export class Clear2FaRequest extends PostRequest {
  constructor(userId: string) {
    super("/user/clear2fa", { user_id: userId });
  }
}

// Алгоритм входа через 2FA:
// 1. Для включения 2FA нужно изменить свойство User_2fa=true , выключить = false , это поле Google2FAOn модели пользователя
// 2. Сразу после этого вызвать и отобразить картинку "/api/create_2fa.png" - ее нужно сохранить
// Теперь
// 1. После любого входа будет получен успешно токен, но статус пользователя будет равен USER_STATUS_NEED_PASS_2FA = 5
// 2. Показываем поле ввода кода Google 2FA Auth
// 3. При вызовов user_info добавляем Code2FA в параметры вызова, равным введенному коду
// 4. Если все хорошо - далее работаем как обычно
// 5. Если код не верен - будет ошибка CM_WRONG_2FA: 116

// Возможные ошибки во всем процессе:

//         CM_WRONG_2FA:      116,
//         CM_NEED_PASS_2FA:  119,
//         CM_NEED_REGEN_2FA: 118,
